import { createSelector } from 'reselect'
import { selectBase } from './selectBase'
import { ACTIVE_PRODUCT_STATES } from '../constants'

export const selectIsInboxActive = createSelector(
  selectBase,
  base => base.inbox && ACTIVE_PRODUCT_STATES.includes(base.inbox.state)
)
